export default {
    meta: {
        app: {
            title: "Espace étudiant",
        },
        home: {
            title: "Accueil"
        }
    },
    header:{
        title:"",
        lang:{
            fr:"fr",
            en:"en"
        },
    },
    home:{
        title: "Eudonet Spécifique",
        subtitle: "Cette page doit être personnalisée pour chacun de vos clients",
    },
    articles: {
        vuejs: {
            title: "Ressources sur VueJs",
        },  
        normes:{
            title: "Normes de développement",
        }
    },
    footer: {
        title: "Propulsé par",
        editor: {
            name: "Eudonet",
            url: "https://fr.eudonet.com"
        },
    }
}